// true  → reserved (pendiente de firma) cuenta como Invertido (se suma a la barra)
// false → reserved cuenta como Reservado (amarillo, fuera de la barra)
export const RESERVED_AS_INVESTED: boolean = false;
